define('home/main',[  // eslint-disable-line requirejs/amd-function-arity
    'home/config',
    'home/utils/layoutUtils',
    'Router',
    'home/models/Session',
    'core/config/urls',

    'jquery',
    'backbone',

    'home/mixins/asEmbedApp',
    'home/utils/sidebarUtils',
    'home/utils/navigationUtils',

    // imported for side effects
    'bootstrap/dropdown',
    'bootstrap/tooltip',
    'bootstrap/modal',
    'bootstrap/collapse',
    'jquery.trunk8',
], function (
    config,
    layoutUtils,

    Router,
    Session,
    urls,

    $,
    Backbone,

    asEmbedApp,
    sidebarUtils,
    navigationUtils
) {
    'use strict';

    var initFixtures = function (callback) {
        if (window.IS_DEV)
            require(['fixtures/fixtures'], callback);
        else
            callback();
    };

    /**
     * Backwards compatibility layer to support old #-based routes
     * e.g., /home/#account
     */
    function transitionUrl() {
        var location = window.location;

        // If we are at the /home/ prefix and we happen to also have a
        // hash that matches one of our routes, then we should try to
        // direct the user to that route instead of just going to /home/.
        // NOTE: this hash routing feature is only to support a few legacy
        //       urls like disqus.com/home/#account.
        if (location.hash.length > 1 && (location.pathname === '/home' || location.pathname === '/home/')) {
            // Construct a new location object that contains the hash's route
            // as well as search params, etc.
            var loc = {
                pathname: '/home/' + location.hash.slice(1).replace(/^\//, ''),
                search: location.search,
                hash: '',
                host: location.host,
            };

            if (navigationUtils.matchesRoute(loc))
                return navigationUtils.navigate(loc, true);
        }

        return Backbone.history.loadUrl();
    }

    return {
        _init: function (options) {
            var app = new Router(options);

            // Start
            app.bootstrap();

            // overwrite tooltip support so they don't show
            if (layoutUtils.isNarrowLayout())
                $.fn.tooltip = $.noop;

            window.DISQUS = window.DISQUS || {};
            window.DISQUS.home = {
                app: app,
            };

            // Wait for fixtures to initialize (for dev) before beginning navigation
            initFixtures(function () {
                Backbone.history.start({
                    pushState: true,
                    hashChange: false,
                    root: config.appRoot,
                    silent: true,
                });

                // If we don't have a matching route, call notFound
                if (!transitionUrl())
                    app.notFound();
            });
        },

        init: function (options) {
            urls.cdn = options.CDN_ROOT;
            var self = this;

            if (sidebarUtils.isSidebar())
                asEmbedApp(Router.prototype, Session.prototype);

            $(function () {
                self._init(options);
            });
        },
    };
});

